
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class OwnStockBifurcationKaratWiseGrid extends _Ext.GridBase<TabAurous.Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.OwnStockKaratWise'; }
        protected getIdProperty() { return "id"; }
        protected getLocalTextPrefix() { return TabAurous.Stock.StockItemRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.OwnStockKaratWiseService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
            (this.view.params as ReportFiltersRequest).ItemTypeId = 101;
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.addDateRangeFilter("VoucherDate", "Date");
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();


            //var plugin = new Slick.ColumnGroup();
            //grid.registerPlugin(plugin);
            //var columns = grid.getColumns();
            //plugin.enableColumnGrouping();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());


            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Pieces'),
                    new Slick.Aggregators.Sum('Weight'),
                    new Slick.Aggregators.Sum('DiamondWeight'),
                    new Slick.Aggregators.Sum('StoneWeight')]
            });


            this.view.setGrouping([{
                
                getter: 'KaratName',
                displayTotalsRow: false,
            }, {
                
                getter: 'StockType',
                displayTotalsRow: false,
            }])

            return grid;
        }
         
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button"); 
            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: TabAurous.Stock.OwnStockKaratWiseService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            return buttons;
        }
    }
}